import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createVNode as _createVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-8f562358")

_pushScopeId("data-v-8f562358")
const _hoisted_1 = { class: "options-panel" }
const _hoisted_2 = { class: "d-flex flex-column flex-lg-row gap-6" }
const _hoisted_3 = { class: "option-sidebar" }
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between gap-3" }
const _hoisted_5 = { class: "fw-semibold fs-7" }
const _hoisted_6 = {
  key: 0,
  class: "badge badge-light-secondary mt-2"
}
const _hoisted_7 = { class: "flex-grow-1" }
const _hoisted_8 = /*#__PURE__*/_createVNode("h6", { class: "mb-4" }, "Contact Update", -1)
const _hoisted_9 = { class: "alert alert-light-primary d-flex align-items-start mb-5" }
const _hoisted_10 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4 mt-1" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "fs-7" }, [
  /*#__PURE__*/_createVNode("strong", null, "Why enable contact capture"),
  /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-2" }, " Enable contact capture so conversations automatically enrich the prospect record in AI 24/7. When a field is missing, the AI will ask naturally during the chat and save the answer to the contact. ")
], -1)
const _hoisted_12 = { class: "form-check form-check-custom form-check-solid mb-5" }
const _hoisted_13 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "askForEmail"
}, "Ask for email", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-5" }, " Turn this on when many chats start without an email (e.g. Facebook, Instagram, Web Chat). Your team needs email for newsletters, appointment confirmations, and long-form follow-up. ", -1)
const _hoisted_15 = { class: "form-check form-check-custom form-check-solid mb-5" }
const _hoisted_16 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "askForPhone"
}, "Ask for phone", -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-0" }, " Turn this on when you want SMS or call follow-up but the contact record has no phone yet. The AI asks once during the conversation and saves the number. It will not re-ask on SMS threads where the phone is already known. ", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("h6", { class: "mb-4" }, "Image Reading", -1)
const _hoisted_19 = { class: "alert alert-light-primary d-flex align-items-start mb-5" }
const _hoisted_20 = { class: "svg-icon svg-icon-2hx svg-icon-primary me-4 mt-1" }
const _hoisted_21 = /*#__PURE__*/_createVNode("div", { class: "fs-7" }, [
  /*#__PURE__*/_createVNode("strong", null, "Why enable image reading"),
  /*#__PURE__*/_createVNode("p", { class: "mb-0 mt-2" }, " When contacts send images in chat, the AI can read what is in the image and remember it in the conversation. This helps the agent respond to screenshots, photos, and other visual messages on channels like Facebook, Instagram, and Web Chat. ")
], -1)
const _hoisted_22 = { class: "form-check form-check-custom form-check-solid mb-5" }
const _hoisted_23 = /*#__PURE__*/_createVNode("label", {
  class: "form-check-label",
  for: "imageReadingEnabled"
}, "Enable image reading", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-muted fs-7 mb-0" }, " Turn this on when contacts often send photos or screenshots. The AI describes what it sees and keeps that context in the conversation history for later replies. ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.optionItems, (item) => {
          return (_openBlock(), _createBlock("div", {
            key: item.key,
            class: ["option-item", {
            active: _ctx.selectedOption === item.key,
            disabled: item.disabled
          }],
            onClick: ($event: any) => (_ctx.selectOption(item))
          }, [
            _createVNode("div", _hoisted_4, [
              _createVNode("span", _hoisted_5, _toDisplayString(item.label), 1)
            ]),
            (item.disabled)
              ? (_openBlock(), _createBlock("span", _hoisted_6, "Coming soon"))
              : _createCommentVNode("", true)
          ], 10, ["onClick"]))
        }), 128))
      ]),
      _createVNode("div", _hoisted_7, [
        (_ctx.selectedOption === 'contactUpdate')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _hoisted_8,
              _createVNode("div", _hoisted_9, [
                _createVNode("span", _hoisted_10, [
                  _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                ]),
                _hoisted_11
              ]),
              _createVNode("div", _hoisted_12, [
                _withDirectives(_createVNode("input", {
                  id: "askForEmail",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.options.contactUpdate.askForEmail = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  disabled: _ctx.readonly
                }, null, 8, ["disabled"]), [
                  [_vModelCheckbox, _ctx.options.contactUpdate.askForEmail]
                ]),
                _hoisted_13
              ]),
              _hoisted_14,
              _createVNode("div", _hoisted_15, [
                _withDirectives(_createVNode("input", {
                  id: "askForPhone",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.options.contactUpdate.askForPhone = $event)),
                  class: "form-check-input",
                  type: "checkbox",
                  disabled: _ctx.readonly
                }, null, 8, ["disabled"]), [
                  [_vModelCheckbox, _ctx.options.contactUpdate.askForPhone]
                ]),
                _hoisted_16
              ]),
              _hoisted_17
            ], 64))
          : (_ctx.selectedOption === 'imageReading')
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _hoisted_18,
                _createVNode("div", _hoisted_19, [
                  _createVNode("span", _hoisted_20, [
                    _createVNode(_component_inline_svg, { src: "media/icons/duotone/Code/Info-circle.svg" })
                  ]),
                  _hoisted_21
                ]),
                _createVNode("div", _hoisted_22, [
                  _withDirectives(_createVNode("input", {
                    id: "imageReadingEnabled",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.options.imageReading.enabled = $event)),
                    class: "form-check-input",
                    type: "checkbox",
                    disabled: _ctx.readonly
                  }, null, 8, ["disabled"]), [
                    [_vModelCheckbox, _ctx.options.imageReading.enabled]
                  ]),
                  _hoisted_23
                ]),
                _hoisted_24
              ], 64))
            : _createCommentVNode("", true)
      ])
    ])
  ]))
})